const OBJECT_URL_REVOKE_DELAY_MS = 10000;

export const downloadFile = (file, fileName, extension = 'csv') => {
  const url = window.URL.createObjectURL(new Blob([file]));

  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${fileName}.${extension}`);

  document.body.appendChild(link);
  link.click();

  link.remove();
};

export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;

  document.body.append(link);
  link.click();

  link.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), OBJECT_URL_REVOKE_DELAY_MS);
};
